import { Icon } from './Icon';

/**
 * Stern zum Merken einer Aufgabe – persönlich, nur für mich sichtbar. Nicht gemerkt erscheint er in Zeilen und Karten
 * erst beim Überfahren (am Handy blass). Ohne onUmschalten (z. B. archiviertes Projekt) nur Anzeige, falls gemerkt.
 * gross = Knopf mit Beschriftung (Detailbereich).
 */
export function MerkStern({ gemerkt, onUmschalten, gross, titel, testid = 'merk-stern' }: {
  gemerkt?: boolean; onUmschalten?: () => void; gross?: boolean;
  /** eigene Infotexte [gemerkt, nicht gemerkt] – z. B. für Favoriten auf der Startseite */
  titel?: [string, string]; testid?: string;
}) {
  if (!onUmschalten) return gemerkt ? <span className="merk-stern an" title={titel?.[0] ?? 'Von Ihnen gemerkt'} data-testid={testid}><Icon name="stern" voll size={gross ? 17 : 15} /></span> : null;
  return (
    <button type="button" className={(gross ? 'btn small ' : '') + 'merk-stern' + (gemerkt ? ' an' : '') + (gross ? ' gross' : '')} aria-pressed={!!gemerkt}
      title={gemerkt ? titel?.[0] ?? 'Nicht mehr merken' : titel?.[1] ?? 'Für mich merken (nur für Sie sichtbar)'} data-testid={testid}
      onClick={(e) => { e.preventDefault(); e.stopPropagation(); onUmschalten(); }}>
      <Icon name="stern" voll={gemerkt} size={gross ? 17 : 15} />{gross && (gemerkt ? 'Gemerkt' : 'Merken')}
    </button>
  );
}
